import React from 'react';
import PropTypes from 'prop-types';
import Button from '@/components/Button';
import CarouselContainer from '@/components/CarouselContainer';
import { createUrlWithLkId } from '@/utils/utils';
import PlaceHolder from '@/components/PlaceHolder';
import VehicleCards from './VehicleCards';
import useFetchRecommendedVehicles from './useFetchRecommendedVehicles';
import useLastSearchUrl from './useLastSearchUrl';
import * as S from './style';

const RecommendedVehiclesNewV2 = ({
  vehicleType,
  title,
  idAdvertise,
  showPlaceHolder = true,
  showMoreOffersButton = true,
  eventName = '',
  origin, 
  lkIds,
  idCampaign,
  centerTitle = false
}) => {
  const { result, isLoading } = useFetchRecommendedVehicles(idAdvertise, idCampaign);
  const urlLastSearch = useLastSearchUrl(vehicleType);

  if (isLoading && showPlaceHolder) {
    return (
      <div className="placeholder-recapture">
        <PlaceHolder />
      </div>
    );
  }

  return (
    <S.RecommendContainer centerTitle={centerTitle}>
      {result && result.length > 0 && (
        <CarouselContainer centerTitle={centerTitle}  title={title || 'Você também pode gostar'}>
          <div className="ContainerCardVehicle RecommendedVehicles">
            <VehicleCards
              searchResults={result}
              vehicleType={vehicleType}
              eventName={eventName}
              lkIds={lkIds}
            />
          </div>
        </CarouselContainer>
      )}

      {showMoreOffersButton && (
        <Button
          className="btn-more-recapture Button--outline-red"
          linkTo={createUrlWithLkId(urlLastSearch, '1972')}
          target="_blank"
        >
          Ver mais ofertas
        </Button>
      )}
    </S.RecommendContainer>
  );
};

RecommendedVehiclesNewV2.propTypes = {
  vehicleType: PropTypes.string.isRequired,
  idAdvertise: PropTypes.string.isRequired,
  title: PropTypes.string,
  showPlaceHolder: PropTypes.bool,
  showMoreOffersButton: PropTypes.bool,
  eventName: PropTypes.string,
  origin: PropTypes.string, 
  lkIds: PropTypes.array.isRequired, 
  idCampaign: PropTypes.number.isRequired,
};

RecommendedVehiclesNewV2.defaultProps = {
  title: '',
  showPlaceHolder: true,
  showMoreOffersButton: true,
  eventName: '',
  origin: '',
  idCampaign: '',
};

export default RecommendedVehiclesNewV2;
